import { useTranslation } from "react-i18next"
import { useUpsertCoachLeaveMutation } from "@/hooks/api/useCoachQuery"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"

import "./LeaveCoachDialog.scss"
import { createGlobalStore } from "@/stores/global"

export default function LeaveCoachDialog({
  selectedId,
  setSelectedId,
  open,
  onClose,
}: {
  selectedId: number
  setSelectedId: (id: number) => void
  open: boolean
  onClose: () => void
}) {
  const { t } = useTranslation("")
  const { mutate: leaveCoach } = useUpsertCoachLeaveMutation()
  const setSnackBar = createGlobalStore((state) => state.setSnackBar)

  const onRemove = () => {
    leaveCoach(selectedId)
    setSelectedId(0)
    setSnackBar({ message: t("messages.successDelete"), severity: "success", open: true })
    onClose()
  }

  return (
    <Dialog
      className="LeaveCoachDialogCont"
      title={t("confirm")}
      open={open}
      onClose={onClose}
      maxWidth="400px"
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={onClose}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton type="danger-outlined" size="md" onClick={onRemove}>
            {t("button.remove")}
          </BasicButton>
        </>
      }>
      {t("messages.confirmRemove")}
    </Dialog>
  )
}
